import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createAdvisoryBoard,
  getAdvisoryBoard,
  resetState,
  updateAdvisoryBoard,
} from "../features/AdvisoryBoard/AdvisoryBoardSlice";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  post: yup.string().required("Post is Required"),
  about: yup.string().required("About is Required"),
  image: yup.mixed().required("Image is Required"),
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.advisoryBoard);
  const [imageErrorone, setImageErrorone] = useState("");
    const {
    isSuccess,
    isError,
    isLoading,
    updatedAdvisoryBoard,
    chaptersname,
    chapterspost,
    chaptersabout,
    createdAdvisoryBoard,
  } = newNewsCategory;
  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getAdvisoryBoard(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createdAdvisoryBoard) {
      toast.success("Advisory Board Added Successfullly!");
      navigate("/admin/Advisory-Board-list");
    }
    if (isSuccess && updatedAdvisoryBoard) {
      toast.success("Advisory Board Updated Successfullly!");
      navigate("/admin/Advisory-Board-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: chaptersname|| "",
      post:chapterspost||"",
      about: chaptersabout|| "",
      image: null,
    
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("post", values.post);
      formData.append("about", values.about);    
      formData.append("image", values.image);
      formData.append("id",getNewsCatId);
     console.log(formData);
      if (getNewsCatId !== undefined) {
        dispatch(updateAdvisoryBoard(formData));
        dispatch(resetState());
      } else {
        dispatch(createAdvisoryBoard(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Board Member
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="name"
            onChng={formik.handleChange("name")}
            onBlr={formik.handleBlur("name")}
            val={formik.values.name}
            label="Enter Name"
          />
          <div className="error">
            {formik.touched.name && formik.errors.name}
          </div>


          <CustomInput
            type="text"
            label="Enter Post"
            name="post"
            onChng={formik.handleChange("post")}
            onBlr={formik.handleBlur("post")}
            val={formik.values.post}
          />
          <div className="error">{formik.touched.post && formik.errors.post}</div>



          <CustomInput
            type="text"
            label="Enter About"
            name="about"
            onChng={formik.handleChange("about")}
            onBlr={formik.handleBlur("about")}
            val={formik.values.about}
          />
          <div className="error">{formik.touched.about && formik.errors.about}</div>

         

          <div className="mt-4">
            <label htmlFor="image" className="form-label">Select Home Image file</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue("image", e.currentTarget.files[0]);
                setImageErrorone(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.image && formik.errors.image}</div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} Board Member
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
